webshop.ProductGrid = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not grid view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "Grid View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = ``;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 90 ? title.substr(0, 90) + "..." : title;

			html += `<div class="col-sm-4 item-card"><div class="card text-left">`;
			html += me.get_image_html(item, title);
			html += me.get_card_body_html(item, title, me.settings);
			html += `</div></div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		this.append_qty_events()
	}

	append_qty_events() {

		let me = this

		this.products_section.on("input", ".item-qty-area .item-qty", (event) => {

			let currentValue = event.target.value;
			
			let validValue = currentValue.replace(/[^0-9]/g, "");
			
			event.target.value = validValue;
		})
		this.products_section.on("click", ".item-qty-area .up-qty", (event) => {

			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");

			let currentValue = parseInt(item_qty.val()) || 0;
			
			item_qty.val(currentValue + 1);
		})
		this.products_section.on("click", ".item-qty-area .dwn-qty", (event) => {

			let item_qty = $(event.target).closest(".item-qty-area").find(".item-qty");

			let currentValue = parseInt(item_qty.val()) || 0;
			
			item_qty.val(Math.max(currentValue - 1, 0));
		})
	}

	get_image_html(item, title) {
		let image = item.website_image;

		if (image) {
			return `
				<div class="card-img-container">
					<a href="/${ item.route || '#' }" style="text-decoration: none;">
						<img itemprop="image" class="card-img" src="${ image }" alt="${ title }">
					</a>
				</div>
			`;
		} else {
			return `
				<div class="card-img-container">
					<a href="/${ item.route || '#' }" style="text-decoration: none;">
						<div class="card-img-top no-image">
							${ frappe.get_abbr(title) }
						</div>
					</a>
				</div>
			`;
		}
	}

	get_card_body_html(item, title, settings) {
		let body_html = `
			<div class="card-body text-left card-body-flex" style="width:100%">
				<div style="margin-top: 1rem; display: flex;">
		`;
		body_html += this.get_title(item, title);

		// get floating elements
		if (!item.has_variants) {
			if (settings.enable_wishlist) {
				body_html += this.get_wishlist_icon(item);
			}
			if (settings.enabled) {
				body_html += this.get_cart_indicator(item);
			}

		}

		body_html += `</div>`;
		body_html += `<div class="product-category" itemprop="name">${ item.item_group || '' }</div>`;

		if (item.formatted_price) {
			body_html += this.get_price_html(item);
		}

		body_html += this.get_stock_availability(item, settings);
		body_html += this.get_quantity_control(item, settings);
		body_html += this.get_primary_button(item, settings);
		body_html += `</div>`; // close div on line 49

		return body_html;
	}

	get_title(item, title) {
		let title_html = `
			<a href="/${ item.route || '#' }">
				<div class="product-title" itemprop="name">
					${ title || '' }
				</div>
			</a>
		`;
		return title_html;
	}

	get_wishlist_icon(item) {
		let icon_class = item.wished ? "wished" : "not-wished";
		return `
			<div class="like-action ${ item.wished ? "like-action-wished" : ''}"
				data-item-code="${ item.item_code }">
				<svg class="icon sm">
					<use class="${ icon_class } wish-icon" href="#icon-heart"></use>
				</svg>
			</div>
		`;
	}

	get_cart_indicator(item) {

		let font_size = 14

		if (item.in_cart_qty > 100) {
			font_size = 13
		}

		return `
			<a href="/cart">
				<div class="cart-indicator ${item.in_cart ? '' : 'hidden'}" data-item-code="${ item.item_code }" style="font-size: ${font_size}px">
					${item.in_cart_qty}
				</div>
			</a>
		`;
	}

	get_price_html(item) {
		let price_html = `
			<div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			price_html += `
				<small class="striked-price">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}
		price_html += `</div>`;
		return price_html;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `
					<span class="out-of-stock mb-2 mt-1" style="color: var(--primary-color)">
						${ __("Available on backorder") }
					</span>
				`;
			} else if (!item.in_stock) {
				return `
					<span class="out-of-stock mb-2 mt-1">
						${ __("Out of stock") }
					</span>
				`;
			}
		}

		return ``;
	}

	get_quantity_control(item, settings) {
		if (settings.enabled && (!item.has_variants && (settings.allow_items_not_in_stock || item.in_stock))) {
			return `
				<div class="d-flex w-100 item-qty-area">
					<div>
						<div class="price-chart-btn column-sm-view d-flex mr-3" data-item-code="${ item.item_code }">
							<span>
								<svg class="show-price-chart" height="14px" width="14px" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M13.374 3C12.2848 1.48593 10.5075 0.5 8.5 0.5C5.18629 0.5 2.5 3.18629 2.5 6.5V8.5C2.5 11.8137 5.18629 14.5 8.5 14.5C10.5075 14.5 12.2848 13.5141 13.374 12M0 5.5H7M0 9.5H7" stroke="#000000"/>
								</svg>
							</span>
						</div>
					</div>
					<div class="input-group number-spinner" style="max-width:100px;">
						<span class="input-group-prepend d-sm-inline-block">
							<button class="item-qty-btn dwn-qty" data-dir="dwn">
								–
							</button>
						</span>

						<input class="form-control text-center item-qty" value="" min="0" data-item-code="${ item.item_code }">

						<span class="input-group-append d-sm-inline-block">
							<button class="item-qty-btn up-qty" data-dir="up">
								+
							</button>
						</span>
					</div>
				</div>
			`;
		} else {
			return ``;
		}
	}

	get_primary_button(item, settings) {
		if (item.has_variants) {
			return `
				<a href="/${ item.route || '#' }">
					<div class="btn btn-sm btn-explore-variants w-100 mt-3">
						${ __("Explore") }
					</div>
				</a>
			`;
		} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
			return `
				<div id="${ item.name }" class="btn
					btn-sm btn-primary btn-add-to-cart-list
					w-100 mt-3" data-item-code="${ item.item_code }">
					<span class="mr-2">
						<svg class="icon icon-md">
							<use href="#icon-assets"></use>
						</svg>
					</span>
					${ settings.enable_checkout ? __("Add to Cart") :  __("Add to Quote") }
				</div>
			`;
		} else {
			return ``;
		}
	}
};
